export const outlineLightGray = "#d4d4d4";

export const contentOutlineStyles = {
    borderRadius:"1em", 
    backgroundColor:"#f4f3f3",
    border:"1px solid " + outlineLightGray
}
